var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex align-center justify-space-between text-body-2"},[_c('div',{staticClass:"title"},[_vm._t("title")],2),_vm._v(" "),_c('div',{staticClass:"count"},[_vm._t("price")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }